export const NOTIFICATION_TYPE_ERROR = 'NOTIFICATION_TYPE_ERROR';
export const NOTIFICATION_TYPE_INFO = 'NOTIFICATION_TYPE_INFO';
export const NOTIFICATION_TYPE_SUCCESS = 'NOTIFICATION_TYPE_SUCCESS';
export const NOTIFICATION_TYPE_WARNING = 'NOTIFICATION_TYPE_WARNING';
